"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _reactCopyToClipboard = require("react-copy-to-clipboard"),
    _classnames = _interopRequireDefault(require("classnames")),
    _utils = require("../../../common/utils");

require("../styles/_player_context_menu.scss");

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var PlayerContextMenu = function (a) {
  function b() {
    var a;
    return (0, _classCallCheck2["default"])(this, b), a = c.call(this), a.hideMenu = function () {
      document.removeEventListener("mousedown", a.handleClick), a.setState({
        coordinates: null
      });
    }, a.showMenu = function (b) {
      b.preventDefault(), b.stopPropagation(), document.addEventListener("mousedown", a.handleClick), a.setState({
        coordinates: {
          x: b.clientX,
          y: b.clientY
        }
      });
    }, a.handleClick = function (b) {
      var c = a._menuRef;
      b && c && !c.contains(b.target) && a.hideMenu();
    }, a.setMenuRef = function (b) {
      b && (a._menuRef = b);
    }, a.state = {
      coordinates: null
    }, a;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleClick);
    }
  }, {
    key: "getMenuOverlay",
    value: function getMenuOverlay() {
      var a = this.state.coordinates;
      if (!a) return null;
      var b = a.x,
          c = a.y;
      return _react["default"].createElement("div", {
        className: "context-menu",
        ref: this.setMenuRef,
        style: {
          left: b,
          top: c
        }
      }, _react["default"].createElement(_reactCopyToClipboard.CopyToClipboard, {
        text: window.location.href,
        onCopy: this.hideMenu
      }, _react["default"].createElement("p", null, "Copy video URL")), _react["default"].createElement(_reactCopyToClipboard.CopyToClipboard, {
        text: (0, _utils.getDebugInfo)(),
        onCopy: this.hideMenu
      }, _react["default"].createElement("p", null, "Copy debug info")));
    }
  }, {
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.children,
          c = a.isDisabled,
          d = this.getMenuOverlay();
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])("overlay-container", {
          "overlay-container__disabled": c
        }),
        role: "button",
        tabIndex: 0,
        onClick: this.handleClick,
        onContextMenu: this.showMenu
      }, d, b);
    }
  }]), b;
}(_react.Component),
    _default = PlayerContextMenu;

exports["default"] = _default;